import { Button } from '@sunwebgroup/uds-ui/button'
import { Sheet } from '@sunwebgroup/uds-ui/sheet'
import { useIntl } from '@/intl'
import { useBookingDetailsActions } from '@/scopes/account/booking-details/infrastructure/dependencies/dependencies'
import { useBookingDetailsStore } from '@/scopes/account/booking-details/infrastructure/useBookingDetailsStore'
import styles
  from '@/scopes/account/booking-details/pages/components/CancelBookingAction/CancelBookingAction.module.css'
import { CancelBookingForm } from '@/scopes/account/booking-details/pages/components/CancelBookingAction/CancelBookingForm'
import {
  getIsCancelBookingActionShown,
  getIsCancelBookingDialogOpen,
} from '@/scopes/account/booking-details/pages/selectors'

export function CancelBookingAction() {
  const { formatMessage } = useIntl()
  const { cancelBookingDialogOpened, cancelBookingDialogClosed } = useBookingDetailsActions()
  const open = useBookingDetailsStore(getIsCancelBookingDialogOpen)
  const shouldBeShown = useBookingDetailsStore(getIsCancelBookingActionShown)

  function handleOpenChange(nextOpen: boolean) {
    if (!nextOpen) {
      cancelBookingDialogClosed()
    }
  }

  if (!shouldBeShown) {
    return null
  }

  return (
    <Sheet.Root open={open} onOpenChange={handleOpenChange}>
      <Button variant="transparentPrimary" className={styles.actionButton} onClick={cancelBookingDialogOpened}>
        <Button.Icon glyph="DismissInCircle" />
        {formatMessage({ id: 'booking_details_cancel_booking_button_label' })}
      </Button>
      <Sheet.Body side="right">
        <CancelBookingForm
          open={open}
          onClose={cancelBookingDialogClosed}
        />
      </Sheet.Body>
    </Sheet.Root>
  )
}
